import { usePathname, useSearchParams } from "next/navigation";
import { useState, useTransition } from "react";
import { usePRouter } from "./use-p-router";

const REGEX_NUMBER_ONLY = /^[0-9\b]+$/;

const useFilter = () => {
  const [activeCategory, setActiveCategory] = useState("");
  const [minPrice, setMinPrice] = useState();
  const [maxPrice, setMaxPrice] = useState();
  const [ratingFilter, setRatingFilter] = useState();
  const [currentWeightFilter, setCurrentWeightFilter] = useState([,]);
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const [, startTransition] = useTransition();
  const router = usePRouter();

  const onChangeMinPrice = (event) => {
    if (event.target.value === "" || REGEX_NUMBER_ONLY.test(event.target.value)) {
      setMinPrice(event.target.value);
    }
  };

  const onChangeMaxPrice = (event) => {
    if (event.target.value === "" || REGEX_NUMBER_ONLY.test(event.target.value)) {
      setMaxPrice(event.target.value);
    }
  };

  const onFilterPriceRange = () => {
    const params = new URLSearchParams(searchParams);
    if (minPrice) {
      params.set("minPrice", minPrice);
    } else {
      params.delete("minPrice");
    }
    if (maxPrice) {
      params.set("maxPrice", maxPrice);
    } else {
      params.delete("maxPrice");
    }
    startTransition(() => {
      if (minPrice || maxPrice) {
        params.delete("page");
        router.push(`${pathname}?${params.toString()}`);
      }
    });
  };

  const onFilterRating = (rating) => {
    const params = new URLSearchParams(searchParams);
    if (rating !== ratingFilter) {
      params.set("ratingValue", rating);
      setRatingFilter(rating);
    } else {
      params.delete("ratingValue");
      setRatingFilter(undefined);
    }
    params.delete("page");
    startTransition(() => {
      router.push(`${pathname}?${params.toString()}`);
    });
  };

  const onFilterWeight = (weightRange) => {
    const [minWeight, maxWeight] = weightRange;
    const params = new URLSearchParams(searchParams);
    const [currentMinWeight, currentMaxWeight] = currentWeightFilter;
    if (minWeight !== currentMinWeight || maxWeight !== currentMaxWeight) {
      setCurrentWeightFilter([minWeight, maxWeight]);
      if (minWeight) {
        params.set("minWeight", minWeight);
      } else {
        params.delete("minWeight");
      }
      if (maxWeight) {
        params.set("maxWeight", maxWeight);
      } else {
        params.delete("maxWeight");
      }
    } else {
      setCurrentWeightFilter([,]);
      params.delete("minWeight");
      params.delete("maxWeight");
    }
    params.delete("page");
    startTransition(() => {
      router.push(`${pathname}?${params.toString()}`);
    });
  };

  return {
    activeCategory,
    minPrice,
    maxPrice,
    ratingFilter,
    setActiveCategory,
    onChangeMinPrice,
    onChangeMaxPrice,
    onFilterPriceRange,
    onFilterRating,
    onFilterWeight,
  };
};

export default useFilter;
